export default {
  addOns: "Extra's",
  all: 'Alle',
  browse: 'Bladeren',
  buyTickets: 'Koop tickets',
  countSelected: '{{count}} geselecteerd',
  joinWaitlist: 'Schrijf je in op de wachtlijst',
  joining: 'Inschrijven',
  salesEnded: 'Verkoop beëindigd',
  schedule: 'Schema',
  soldOut: 'Uitverkocht',
  tickets: 'Tickets',
  noDatesAvailable: 'Geen datums beschikbaar',
  seeMoreDates: 'Meer datums bekijken',
  about: 'Over',
  agenda: 'Programma',
  menu: 'Menu',
  included: 'Inbegrepen',
  viewMore: 'Meer bekijken',
  viewLess: 'Minder bekijken',
  location: 'Locatie',
  time: 'Tijd',
  at: 'om',
  noTimesAvailableOnThisDateFotThisPartySize:
    'Geen tijden beschikbaar op deze datum voor dit gezelschap',
  availableTimes: 'Beschikbare tijden',
  waitlist: 'Wachtlijst',
  continue: 'Doorgaan',
  ticketsAreNoLongerAvailable: 'Tickets zijn niet meer beschikbaar.',
  checkOutOutOtherExperiences: 'Bekijk onze andere ervaringen!',
  viewExperiences: 'Ervaringen bekijken',
  from: 'vanaf',
  cancellationPolicy: 'Annuleringsbeleid',
  rsvp: 'RSVP',
  nights: 'nachten',
  request: 'Aanvraag',
  arrival: 'Aankomst',
  departure: 'Vertrek',
};
